module.exports = __webpack_public_path__ + "static/media/speaker2019.d6bc37ea.png";